export default __webpack_public_path__ + "static/media/Anhållan om ledighet.feb31bbd.pdf";